import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";
import useActiveItem from "hooks/useActiveItem";
import ActiveItemCombine from "./active-item/ActiveItemCombine";
import ActiveItem from "./active-item/ActiveItem";
import MainFilters from "./main-components/MainFilters";
import CraftIdentityMatches from "./craft-identity/CraftIdentityMatches";
import CraftPredictionEligibles from "./craft-prediction/CraftPredictionEligibles";
import ActiveItemIdentityMatches from "./active-item/ActiveItemIdentityMatches";

const ScrollComponent = ({ filters, setOffsetCount, parentRef }) => {
  const { activeItem } = useActiveItem();
  const swiperRef = useRef(null);
  const { pathname } = useLocation();

  const updateSwiper = () => {
    if (swiperRef.current) {
      swiperRef.current.update();
    }
  };

  useEffect(() => {
    if (!parentRef?.current) return;

    const resizeObserver = new ResizeObserver(() => {
      updateSwiper();
    });

    resizeObserver.observe(parentRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [parentRef, filters]);

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(0, 0);
      swiperRef.current.update();
    }
  }, [activeItem]);

  return (
    <Swiper
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
      direction={"vertical"}
      slidesPerView={"auto"}
      freeMode={true}
      mousewheel={{
        releaseOnEdges: true
      }}
      modules={[FreeMode, Mousewheel]}
      height={500}
    >
      {(pathname.includes("/prizes") ||
        pathname.includes("/inventory/card-packs")) && (
        <SwiperSlide>
          <ActiveItemCombine />
        </SwiperSlide>
      )}
      {activeItem && (
        <SwiperSlide>
          <ActiveItem parentSwiper={swiperRef} />
        </SwiperSlide>
      )}
      {activeItem &&
        (pathname.includes("/dates") ||
          pathname.includes("/categories") ||
          pathname.includes("/marketplace")) &&
        ["category", "month", "day", "year"].includes(
          activeItem.type.toLowerCase()
        ) && (
          <SwiperSlide>
            <ActiveItemIdentityMatches
              parentSwiper={swiperRef}
              item={activeItem}
            />
          </SwiperSlide>
        )}
      {pathname.includes("/crafting/identity") && (
        <SwiperSlide>
          <CraftIdentityMatches parentSwiper={swiperRef} />
        </SwiperSlide>
      )}
      {pathname.includes("/crafting/prediction") && (
        <SwiperSlide>
          <CraftPredictionEligibles parentSwiper={swiperRef} />
        </SwiperSlide>
      )}
      {!pathname.includes("/dashboard") &&
        !pathname.includes("/crafting") &&
        filters !== null && (
          <SwiperSlide>
            <MainFilters
              parentSwiper={swiperRef}
              setOffsetCount={setOffsetCount}
              filters={filters}
            />
          </SwiperSlide>
        )}
    </Swiper>
  );
};

export default React.memo(ScrollComponent);
